export default __webpack_public_path__ + "static/media/lycanthropicbite.511f7387.png";